// Builds a success_url for legacy Tornado form endpoints, which redirect to it
// after processing. Dev runs Vite (:3000) and Tornado (:8000) on different
// origins, so a relative redirect from a Tornado response would strand the user
// on :8000; the absolute origin is whitelisted server-side. Elsewhere the app
// and backend share an origin, and a relative URL passes validation in any env.
function getSuccessUrl(path: string): string {
  return import.meta.env.DEV ? `${window.location.origin}${path}` : path;
}

export { getSuccessUrl };
